import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import AdminPage from './pages/admin/AdminPage';
import TenantConfigPage from './pages/config/TenantConfigPage';
import ApiGuidePage from './pages/docs/ApiGuidePage';
import NewRunPage from './pages/runs/NewRunPage';
import RouteDetailPage from './pages/runs/RouteDetailPage';
import RunComparePage from './pages/runs/RunComparePage';
import RunDetailPage from './pages/runs/RunDetailPage';
import RunsPage from './pages/runs/RunsPage';
import MetricsPage from './pages/metrics/MetricsPage';
import WorldPage from './pages/world/WorldPage';

const App = () => (
  <Routes>
    <Route element={<Layout />}>
      <Route path="/" element={<Navigate to="/runs" replace />} />
      <Route path="/runs" element={<RunsPage />} />
      <Route path="/runs/new" element={<NewRunPage />} />
      <Route path="/runs/:runId" element={<RunDetailPage />} />
      <Route path="/runs/:runId/compare" element={<RunComparePage />} />
      <Route path="/runs/:runId/routes/:routeId" element={<RouteDetailPage />} />
      <Route path="/metrics" element={<MetricsPage />} />
      <Route path="/world" element={<WorldPage />} />
      <Route path="/config" element={<TenantConfigPage />} />
      {/* The tenant's config lives at /config now; base config moved into /admin. */}
      <Route path="/tenants" element={<Navigate to="/config" replace />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/docs" element={<ApiGuidePage />} />
      <Route path="*" element={<Navigate to="/runs" replace />} />
    </Route>
  </Routes>
);

export default App;
